import * as colocMarketplaceApi from '@/lib/coloc-api/marketplace';

export const { getSearchRoomAutoCompleteResults, getCitiesList, getInstagramPosts } =
  colocMarketplaceApi;
